import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { householdsApi } from 'src/Services/API';
import { ApiError } from 'src/types/api-error.types';
import { HouseholdDto } from 'src/types/household.types';

const useFetchHouseholds = () => {
  const assetId = useCurrentAssetId();

  return useQuery<HouseholdDto[], AxiosError<ApiError>>({
    queryKey: ['fetch-households', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return householdsApi.list(assetId);
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchHouseholds;
